<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Bulk {{ isAdd ? 'Add' : 'Remove' }} Customer Tag</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="!loadingSave">
      <div class="form-group" *ngIf="isAdd">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" href="#"
               [class.active]="!creatingNewTag"
               (click)="toggleCreatingNewTag(false);$event.preventDefault()">
              Search Existing Tags
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#"
               [class.active]="creatingNewTag"
               (click)="toggleCreatingNewTag(true);$event.preventDefault()">
              Create New Tag
            </a>
          </li>
        </ul>
      </div>

      <ng-container *ngIf="!creatingNewTag">
        <div class="form-group">
          <label for="tagSearchInput">Tag Name</label>
          <input type="text" class="form-control" id="tagSearchInput" name="tagSearchInput"
                 [(ngModel)]="tagSearchInput"
                 (ngModelChange)="tagName = ''">
        </div>

        <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
        <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
             *ngIf="tagName === ''">

          <table class="table table-bordered table-hover">
            <tbody>
            <ng-container *ngIf="tags.length === 0">
              <tr>
                <td>No existing tags.</td>
              </tr>
            </ng-container>
            <ng-container *ngIf="tags.length > 0">
              <tr *ngFor="let tag of getMatchedTags()"
                  class="cursor-pointer"
                  (click)="tagSearchInput = tag;tagName = tag;">
                <td>{{ tag }}</td>
              </tr>
              <tr *ngIf="getMatchedTags().length === 0">
                <td>No tags found.</td>
              </tr>
            </ng-container>
            </tbody>
          </table>

        </div>
      </ng-container>

      <form (ngSubmit)="handleSubmit()" *ngIf="creatingNewTag">
        <div class="form-group">
          <label for="tagInput">Tag Name</label>
          <input type="text" class="form-control" id="tagInput" name="tag"
                 [(ngModel)]="tagName">
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="loadingSave">
      <h4>Loading...</h4>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!saveButtonEnabled()"
            [class.disabled]="!saveButtonEnabled()"
            (click)="handleSubmit()">
      {{ loadingSave ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
